var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 566.278,
    height: 403.644,
    viewBox: "0 0 566.278 403.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2163",
    "data-name": "Group 2163",
    transform: "translate(-56.628 -105.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2163-2",
    "data-name": "Group 2163",
    transform: "translate(101.839 286.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10016",
    "data-name": "Path 10016",
    d: "M115.159,224.825H86.382v25.25l4.393-4.393h24.384Z",
    transform: "translate(-86.382 -224.825)",
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2167",
    "data-name": "Group 2167",
    transform: "translate(69.641 293.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2166",
    "data-name": "Group 2166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2165",
    "data-name": "Group 2165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2164",
    "data-name": "Group 2164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10017",
    "data-name": "Path 10017",
    d: "M83.294,230.757s7.04,3.443,5.3,12.811-2.512,10.63-.564,14.291,4.244,19.273,2.492,22.233-21.689-13.005-24.453-26.4,1.752-19.352,3.349-21.571S77.081,227.6,83.294,230.757Z",
    transform: "translate(-65.192 -229.212)",
    fill: "#0e2d3d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2169",
    "data-name": "Group 2169",
    transform: "translate(89.693 328.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2168",
    "data-name": "Group 2168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10018",
    "data-name": "Path 10018",
    d: "M78.389,252.484a9.806,9.806,0,0,1,5.595,3.691c1.4,2.06,1.513,6.637,1.715,7.5s2.873,10.617,2.873,10.617l-7.464,5Z",
    transform: "translate(-78.389 -252.484)",
    fill: "#285173"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2171",
    "data-name": "Group 2171",
    transform: "translate(107.814 485.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2170",
    "data-name": "Group 2170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10019",
    "data-name": "Path 10019",
    d: "M99.77,365.823s4.871,6.557,4.2,7.6-5.791,1.187-8.909,0-3.191-8.872-4.6-12.174c-.59-1.383.675-5.464,2.449-5.759a7.489,7.489,0,0,1,3.711.573S94.778,360.709,99.77,365.823Z",
    transform: "translate(-90.315 -355.424)",
    fill: "#1d3b54"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2174",
    "data-name": "Group 2174",
    transform: "translate(109.283 485.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2173",
    "data-name": "Group 2173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2172",
    "data-name": "Group 2172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10020",
    "data-name": "Path 10020",
    d: "M96.151,356.038a30.89,30.89,0,0,1,1.4,5.458c.31,2.214,3.471,6.908,3.322,7.5s-4.157,1.132-5.791-.4-2.683-5.984-3.044-8.646a21.412,21.412,0,0,0-.757-3.708S94.592,354.4,96.151,356.038Z",
    transform: "translate(-91.281 -355.362)",
    fill: "#eea886"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2176",
    "data-name": "Group 2176",
    transform: "translate(65.242 485.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2175",
    "data-name": "Group 2175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10021",
    "data-name": "Path 10021",
    d: "M71.929,365.93s4.7,6.449,4.027,7.488-5.791,1.187-8.909,0-3.192-8.872-4.6-12.174c-.591-1.383.673-5.464,2.449-5.759a7.985,7.985,0,0,1,3.861.635S66.936,360.818,71.929,365.93Z",
    transform: "translate(-62.297 -355.427)",
    fill: "#1d3b54"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2179",
    "data-name": "Group 2179",
    transform: "translate(67.441 485.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2178",
    "data-name": "Group 2178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2177",
    "data-name": "Group 2177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10022",
    "data-name": "Path 10022",
    d: "M68,356.2a43.862,43.862,0,0,0,.965,5.2c.594,2.155,3.785,7.053,3.638,7.646s-4.157,1.132-5.791-.4S63.92,362.684,63.771,360a14.264,14.264,0,0,1,.371-4.434A3.629,3.629,0,0,1,68,356.2Z",
    transform: "translate(-63.744 -355.267)",
    fill: "#eea886"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2182",
    "data-name": "Group 2182",
    transform: "translate(60.334 365.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2181",
    "data-name": "Group 2181",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2180",
    "data-name": "Group 2180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10023",
    "data-name": "Path 10023",
    d: "M93.9,290.473s4.18,19.443,5.139,24.339,3.648,28.606,3.935,32.637,4.362,19.223,4.171,20.664,6.038,30.364,6.038,30.364a3.749,3.749,0,0,1-4.372.155c-1.153-.8-13.672-27.08-13.672-34.28,0-9.951-7.359-22.941-8.309-25.167-8.821-20.683-7.084-27.007-8.236-28.352s-1.252.831-1.924,3.806-2.111,28.7-2.975,31.966-.193,14.3-.673,19.872-2.586,30.75-2.586,30.75-1.632,2.557-3.922.067c-.492-.536-3.954-28.053-4.049-34.676s-.2-15.759-.384-18.623c-1.778-27.447-6.148-31.368.735-50.792C75.7,256.83,93.9,290.473,93.9,290.473Z",
    transform: "translate(-59.067 -276.298)",
    fill: "#eea886"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2184",
    "data-name": "Group 2184",
    transform: "translate(59.031 373.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2183",
    "data-name": "Group 2183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10024",
    "data-name": "Path 10024",
    d: "M66.271,282.052s-11.907,16.666-6.78,52.116c0,0,28.243,3.841,43.374-4.444,0,0-6.257-36.551-8.524-42.237S66.271,282.052,66.271,282.052Z",
    transform: "translate(-58.209 -282.05)",
    fill: "#1d3b54"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2186",
    "data-name": "Group 2186",
    transform: "translate(107.83 490.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2185",
    "data-name": "Group 2185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10025",
    "data-name": "Path 10025",
    d: "M90.325,358.875v6.866h.891v-5.306Z",
    transform: "translate(-90.325 -358.875)",
    fill: "#1d3b54"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2188",
    "data-name": "Group 2188",
    transform: "translate(65.259 490.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2187",
    "data-name": "Group 2187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10026",
    "data-name": "Path 10026",
    d: "M62.308,358.875v6.866H63.2v-5.306Z",
    transform: "translate(-62.308 -358.875)",
    fill: "#1d3b54"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2190",
    "data-name": "Group 2190",
    transform: "translate(61.283 326.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2189",
    "data-name": "Group 2189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10027",
    "data-name": "Path 10027",
    d: "M81.482,250.962a45.738,45.738,0,0,0,5.911,2.376c1.523.3,7.433,7.982,8.47,10.785s0,7.006-2.133,11.94-.122,6.581-1.1,11.516a114.785,114.785,0,0,0-1.644,18.128c.182,2.743-24.645,3.261-30.311-1.737,0,0,5.7-8.53,6.426-9.748s.122-7.86-.549-9.565-5.13-16.214-5.13-16.214-3.65-11.142-.354-13.7c2.864-2.226,10.668-3.016,12.069-3.5A23.956,23.956,0,0,1,81.482,250.962Z",
    transform: "translate(-59.692 -250.734)",
    fill: "#eddad3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    "data-name": "Group 2192",
    transform: "translate(84.347 324.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2191",
    "data-name": "Group 2191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10028",
    "data-name": "Path 10028",
    d: "M75,261.2l2.665-3.121-2.316-8.219A54.3,54.3,0,0,0,75,261.2Z",
    transform: "translate(-74.871 -249.857)",
    fill: "#d6c5be"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194",
    transform: "translate(74.731 315.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2193",
    "data-name": "Group 2193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10029",
    "data-name": "Path 10029",
    d: "M78.979,249.606s-.12,1.1-.263,2.62c-.061.675-.129,1.431-.191,2.212a50.056,50.056,0,0,0-.239,5.835s-4.558,4.569-9.745-5.33a13.6,13.6,0,0,0,.541-9.643C67.439,239.741,78.979,249.606,78.979,249.606Z",
    transform: "translate(-68.542 -243.601)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    "data-name": "Group 2196",
    transform: "translate(79.229 332.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10030",
    "data-name": "Path 10030",
    d: "M76.748,254.573v4.174l-5.246-3.92Z",
    transform: "translate(-71.502 -254.573)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2198",
    "data-name": "Group 2198",
    transform: "translate(72.586 326.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10031",
    "data-name": "Path 10031",
    d: "M79.019,260.742l-2.178-2.7L69.5,250.733,67.13,253.02Z",
    transform: "translate(-67.13 -250.733)",
    fill: "#d6c5be"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2200",
    "data-name": "Group 2200",
    transform: "translate(59.026 326.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10032",
    "data-name": "Path 10032",
    d: "M73.121,251.193s6.157,9.346,6.452,13.458-2.288,34.878-4.356,44.767S58.206,308.3,58.206,308.3s10.041-16.253,6.186-29.265-5.254-18.219-5.254-18.219,1.327-7.246,6.026-8.265C69.285,251.658,73.121,251.193,73.121,251.193Z",
    transform: "translate(-58.206 -251.193)",
    fill: "#285173"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2202",
    "data-name": "Group 2202",
    transform: "translate(86.328 327.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2201",
    "data-name": "Group 2201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10033",
    "data-name": "Path 10033",
    d: "M87.7,264.8s1.111,3.929-3.215,12.616c0,0,.068,11.117.19,14.59s2.579,15.961,2.579,15.961l-5.912,3.148a1.207,1.207,0,0,1-1.808-1.187c1.211-10,5.153-47.905-3.363-58.095l3.417,1.007S85.662,257.809,87.7,264.8Z",
    transform: "translate(-76.174 -251.834)",
    fill: "#285173"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2204",
    "data-name": "Group 2204",
    transform: "translate(84.826 324.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2203",
    "data-name": "Group 2203",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10034",
    "data-name": "Path 10034",
    d: "M77.5,258.075l3.359.929-5.674-9.147Z",
    transform: "translate(-75.186 -249.857)",
    fill: "#fae6de"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2206",
    "data-name": "Group 2206",
    transform: "translate(72.929 326.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2205",
    "data-name": "Group 2205",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10035",
    "data-name": "Path 10035",
    d: "M76.724,258.046l-3.068,4.021-6.3-10.5,2.031-.834Z",
    transform: "translate(-67.356 -250.733)",
    fill: "#fae6de"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2207",
    "data-name": "Group 2207",
    transform: "translate(86.742 349.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3580",
    "data-name": "Rectangle 3580",
    width: 1.11,
    height: 13.136,
    transform: "matrix(0.785, -0.62, 0.62, 0.785, 0, 0.688)",
    fill: "#eb4747"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2208",
    "data-name": "Group 2208",
    transform: "translate(84.947 356.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10036",
    "data-name": "Path 10036",
    d: "M76.552,273.138a2.386,2.386,0,0,0,1.29-.372c.884-.666,1.2-2.308,2.764-2.188s2.284,5.013,1.892,5.938-2.557,1.389-5.759.752S76.552,273.138,76.552,273.138Z",
    transform: "translate(-75.266 -270.572)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2209",
    "data-name": "Group 2209",
    transform: "translate(89.155 354.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10037",
    "data-name": "Path 10037",
    d: "M78.631,271.214a48.812,48.812,0,0,1,4.832-1.323c2.272-.492,4.985-.652,5.248-.258.295.439-2.212.818-4.437,1.45-2.05.582-1.561.793-1.561.793s-.135-.067,2.2-.286c2.515-.236,5.1-.231,5.361.272.123.246.036.41-.869.64.544-.024.621.117.641.336.109,1.132-3.56,2.035-5.017,2.392,1.121-.267,1.966-.349,1.564.41-.46.868-5.7,1.918-7.543,2.466C77.041,278.7,78.631,271.214,78.631,271.214Z",
    transform: "translate(-78.035 -269.411)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2210",
    "data-name": "Group 2210",
    transform: "translate(56.628 328.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10038",
    "data-name": "Path 10038",
    d: "M66.851,252.227c-1.542-.5-6.072,1.108-6.836,5.75s-1.073,9.8-1.787,12.3-2.535,13.58-1,14.5,4.431,1.758,8.5,1.758c4.2,0,20.483.731,20.483.731l1.021-5.785s-6.184-.319-9.389-.8c-2.852-.433-6.806-1.647-11.46-2.158a78.076,78.076,0,0,1,1.7-8.8C68.791,267.776,73.792,254.473,66.851,252.227Z",
    transform: "translate(-56.628 -252.14)",
    fill: "#285173"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2211",
    "data-name": "Group 2211",
    transform: "translate(95.761 358.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10039",
    "data-name": "Path 10039",
    d: "M83.253,271.74l.763,1.861-1.635-1.171Z",
    transform: "translate(-82.382 -271.74)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2213",
    "data-name": "Group 2213",
    transform: "translate(87.662 338.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2212",
    "data-name": "Group 2212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10040",
    "data-name": "Path 10040",
    d: "M77.052,288.135l16.4-3.253,12.164-26.027-17.506,1.838Z",
    transform: "translate(-77.052 -258.855)",
    fill: "#e8734d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2216",
    "data-name": "Group 2216",
    transform: "translate(104.591 352.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2215",
    "data-name": "Group 2215",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2214",
    "data-name": "Group 2214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10041",
    "data-name": "Path 10041",
    d: "M89.711,275.858a13.264,13.264,0,0,0,1.7-2c.8-1.17,3.423-5.631,3.183-5.911s-4.132-.375-4.837.26.694.884.694.884-2.127.219-1.975.819,1.433.435,1.433.435-1.712.328-1.453.856,1.083.521,1.083.521-1.518.191-1.33.766,2.588,1.12,2.267,1.6A11.186,11.186,0,0,0,89.711,275.858Z",
    transform: "translate(-88.193 -267.727)",
    fill: "#eea886"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2220",
    "data-name": "Group 2220",
    transform: "translate(73.24 295.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2219",
    "data-name": "Group 2219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2218",
    "data-name": "Group 2218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2217",
    "data-name": "Group 2217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10042",
    "data-name": "Path 10042",
    d: "M81.043,231.015s10.22,3.211,4.672,20.85-19.509-2.044-18.049-12.791S81.043,231.015,81.043,231.015Z",
    transform: "translate(-67.561 -230.716)",
    fill: "#eea987"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2224",
    "data-name": "Group 2224",
    transform: "translate(72.435 294.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2223",
    "data-name": "Group 2223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2222",
    "data-name": "Group 2222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2221",
    "data-name": "Group 2221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10043",
    "data-name": "Path 10043",
    d: "M87.035,241.791A23.055,23.055,0,0,1,73.457,247.4s-3.267,3.831-3.518,5.333c0,0-7.582-12.926,1.738-20.676S90.462,238.6,87.035,241.791Z",
    transform: "translate(-67.031 -229.783)",
    fill: "#0e2d3d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2228",
    "data-name": "Group 2228",
    transform: "translate(75.416 308.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2227",
    "data-name": "Group 2227",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2226",
    "data-name": "Group 2226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2225",
    "data-name": "Group 2225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10044",
    "data-name": "Path 10044",
    d: "M72.539,242.814c-.065-1.284-.855-4.206-2.764-3.388s.117,6.768,1.381,6.4C71.157,245.827,72.7,245.851,72.539,242.814Z",
    transform: "translate(-68.993 -239.284)",
    fill: "#eea987"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2229",
    "data-name": "Group 2229",
    transform: "translate(77.87 318.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10045",
    "data-name": "Path 10045",
    d: "M77.643,251c-.061.675-.129,1.431-.191,2.212h0c-5.909-2.917-6.815-7.125-6.842-7.256C74.819,251.4,77.643,251,77.643,251Z",
    transform: "translate(-70.608 -245.958)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231",
    transform: "translate(255.167 353.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2230",
    "data-name": "Group 2230",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10046",
    "data-name": "Path 10046",
    d: "M187.382,268.408s-1.323,10.213,6.055,18.055,24.019,5.045,24.019,5.045-2.752-9.267-8.786-13.086S190.788,273.287,187.382,268.408Z",
    transform: "translate(-187.289 -268.408)",
    fill: "#869135"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2233",
    "data-name": "Group 2233",
    transform: "translate(260.868 333.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2232",
    "data-name": "Group 2232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10047",
    "data-name": "Path 10047",
    d: "M194.018,255.662s-6.083,11.451-.857,23.962,26.076,16.582,26.076,16.582.86-12.144-4.56-19.316S195.871,262.922,194.018,255.662Z",
    transform: "translate(-191.041 -255.662)",
    fill: "#48753a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2237",
    "data-name": "Group 2237",
    transform: "translate(527.451 178.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2234",
    "data-name": "Group 2234",
    transform: "translate(0 8.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10048",
    "data-name": "Path 10048",
    d: "M375.791,158.779s10.34,15.687,1.617,24.019-9.751-.971-9.751-.971-4.666.307,4.61-10.308C376.64,166.515,375.791,158.779,375.791,158.779Z",
    transform: "translate(-366.484 -158.779)",
    fill: "#bbd070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2235",
    "data-name": "Group 2235",
    transform: "translate(7.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10049",
    "data-name": "Path 10049",
    d: "M400.757,153.51s7.376,14.248-9.983,27.6S373.5,203.658,373.5,203.658,361.281,170.636,400.757,153.51Z",
    transform: "translate(-371.714 -153.51)",
    fill: "#97a43c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2236",
    "data-name": "Group 2236",
    transform: "translate(5.353 17.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10050",
    "data-name": "Path 10050",
    d: "M372.163,191.568c-6.6-.184,3.065-16.936,13.809-20.335s19.323-1.988,25.862-6.143C411.834,165.089,404.649,192.473,372.163,191.568Z",
    transform: "translate(-370.007 -165.089)",
    fill: "#48753a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2238",
    "data-name": "Group 2238",
    transform: "translate(271.446 169.19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3581",
    "data-name": "Rectangle 3581",
    width: 1.387,
    height: 166.048,
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2239",
    "data-name": "Group 2239",
    transform: "translate(169.691 288.666)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3582",
    "data-name": "Rectangle 3582",
    width: 114.634,
    height: 1.388,
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2240",
    "data-name": "Group 2240",
    transform: "translate(313.413 221.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10051",
    "data-name": "Path 10051",
    d: "M469.625,380.069H244.569c-10.447,0-18.947-8.878-18.947-19.794V201.817c0-10.913,8.5-19.791,18.947-19.791H469.625c10.448,0,18.947,8.878,18.947,19.791V360.275C488.572,371.191,480.073,380.069,469.625,380.069ZM244.569,183.691c-9.529,0-17.281,8.132-17.281,18.126V360.275c0,10,7.752,18.129,17.281,18.129H469.625c9.529,0,17.281-8.134,17.281-18.129V201.817c0-9.994-7.752-18.126-17.281-18.126Z",
    transform: "translate(-225.622 -182.026)",
    fill: "#4da8f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2241",
    "data-name": "Group 2241",
    transform: "translate(95.305 105.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10052",
    "data-name": "Path 10052",
    d: "M467.6,349.332c-.568,0-1.129,0-1.687,0l.008-1.665c2.452.014,5.007,0,7.485-.05l.033,1.664C471.511,349.314,469.545,349.332,467.6,349.332ZM458.4,349.2c-2.512-.074-5.04-.181-7.511-.316l.09-1.662c2.459.134,4.972.24,7.471.315Zm22.569-.158-.074-1.664c2.5-.112,5.019-.258,7.471-.433l.12,1.662C486.013,348.777,483.485,348.925,480.965,349.037Zm-37.585-.666c-4.712-.386-7.479-.749-7.5-.754l.216-1.65c.029,0,2.759.362,7.426.743Zm52.6-.412-.167-1.658c2.5-.251,5-.538,7.43-.857l.216,1.652C501.017,347.419,498.5,347.708,495.986,347.96ZM510.916,346l-.27-1.643c2.483-.41,4.955-.86,7.353-1.343l.328,1.632C515.911,345.132,513.417,345.588,510.916,346Zm14.754-2.98-.392-1.618c2.445-.593,4.873-1.235,7.211-1.908l.462,1.6C530.589,341.772,528.141,342.421,525.671,343.018Zm14.476-4.185-.536-1.576c2.384-.813,4.739-1.682,7-2.588l.62,1.547C544.942,337.132,542.56,338.013,540.147,338.834Zm14.013-5.625-.708-1.507c2.276-1.071,4.51-2.209,6.637-3.384l.8,1.457C558.733,330.967,556.468,332.122,554.159,333.209Zm13.22-7.321-.909-1.4c2.1-1.366,4.141-2.81,6.063-4.291l1.015,1.32C571.591,323.028,569.515,324.5,567.379,325.888Zm11.954-9.228-1.126-1.226c1.831-1.681,3.586-3.448,5.221-5.253l1.235,1.118C582.993,313.142,581.2,314.946,579.333,316.66Zm10.127-11.2-1.339-.992c1.468-1.975,2.849-4.043,4.109-6.148l1.431.855C592.372,301.322,590.958,303.437,589.46,305.455Zm7.757-12.954-1.507-.711c1.041-2.2,1.992-4.5,2.831-6.832l1.567.564C599.253,287.9,598.279,290.249,597.217,292.5Zm5.119-14.194-1.612-.421c.611-2.346,1.138-4.782,1.562-7.239l1.644.284C603.494,273.435,602.961,275.916,602.336,278.308Zm2.592-14.85-1.658-.16c.229-2.411.381-4.9.447-7.415l1.667.044C605.316,258.475,605.163,261.008,604.929,263.458Zm-1.247-15.017c-.085-2.424-.245-4.925-.471-7.435l1.659-.15c.231,2.541.392,5.072.476,7.526ZM602.35,233.6c-.337-2.407-.745-4.884-1.2-7.36l1.636-.305c.465,2.5.877,5,1.219,7.433Zm-2.718-14.668c-.205-.9-.419-1.808-.637-2.708-.369-1.521-.772-3.033-1.2-4.493l1.6-.47c.436,1.486.848,3.024,1.222,4.569.219.907.436,1.826.641,2.732Zm-4.2-14.209c-.893-2.319-1.887-4.6-2.958-6.769l1.494-.737c1.093,2.218,2.109,4.542,3.018,6.908ZM83.6,194.47l-1.515-.691c1.05-2.3,2.135-4.586,3.227-6.791l1.492.738C85.718,189.916,84.639,192.185,83.6,194.47ZM588.9,191.5c-1.293-2.091-2.7-4.135-4.186-6.076l1.322-1.012c1.52,1.984,2.958,4.075,4.282,6.213ZM90.228,181.1l-1.466-.79c1.2-2.228,2.442-4.432,3.691-6.555l1.436.845C92.65,176.7,91.419,178.887,90.228,181.1Zm489.707-1.307c-1.662-1.773-3.446-3.5-5.3-5.131l1.1-1.251c1.9,1.667,3.718,3.431,5.417,5.242Zm-11.077-9.757c-1.953-1.425-4.027-2.808-6.163-4.112l.866-1.422c2.177,1.328,4.288,2.737,6.28,4.189ZM97.8,168.246l-1.4-.9c1.369-2.126,2.787-4.223,4.212-6.238l1.36.963C100.559,164.063,99.155,166.142,97.8,168.246ZM556.214,162.3c-2.147-1.1-4.408-2.162-6.724-3.162l.658-1.529c2.349,1.014,4.647,2.094,6.826,3.208Zm-13.642-5.909c-2.269-.828-4.645-1.627-7.064-2.378l.494-1.589c2.443.757,4.846,1.565,7.142,2.4Zm-436.154-.3-1.314-1.026c1.556-1.991,3.167-3.948,4.785-5.817l1.26,1.089C109.547,152.188,107.956,154.123,106.418,156.092Zm421.918-4.125c-2.337-.614-4.777-1.206-7.257-1.761l.363-1.626c2.5.559,4.961,1.156,7.318,1.776Zm-14.573-3.273c-2.377-.451-4.856-.887-7.365-1.295l.267-1.644c2.524.409,5.019.848,7.408,1.3ZM499,146.291c-2.392-.33-4.89-.649-7.424-.948l.194-1.655c2.545.3,5.054.621,7.456.953Zm-382.827-1.447-1.2-1.156c1.754-1.816,3.565-3.589,5.387-5.273l1.131,1.225C119.691,141.3,117.9,143.053,116.172,144.845Zm367.96-.313c-2.4-.242-4.9-.476-7.458-.7l.144-1.659c2.56.222,5.077.457,7.479.7Zm-14.927-1.3c-2.375-.178-4.888-.356-7.473-.526l.108-1.662c2.589.172,5.11.348,7.491.527Zm-14.955-.992q-3.724-.219-7.467-.421l.09-1.664q3.745.205,7.473.422Zm-14.947-.813q-3.567-.182-7.136-.362l-.357-.017.084-1.665.356.018q3.572.18,7.137.362Zm-15-.758q-3.763-.194-7.517-.4l.09-1.664q3.754.2,7.511.4Zm-15.01-.818c-2.644-.157-5.093-.31-7.494-.468l.108-1.662c2.4.158,4.847.312,7.482.466Zm-14.984-.994c-2.572-.194-5.092-.4-7.488-.6l.143-1.659c2.392.205,4.9.409,7.47.6Zm-14.967-1.3c-2.551-.257-5.064-.529-7.471-.81l.194-1.655c2.4.281,4.9.553,7.441.807ZM364.416,135.8c-2.536-.346-5.04-.719-7.436-1.1l.263-1.644c2.386.381,4.875.751,7.4,1.1ZM127.1,134.757l-1.055-1.29c1.945-1.592,3.958-3.138,5.979-4.593l.974,1.352C131,131.66,129.021,133.186,127.1,134.757Zm222.469-1.342c-2.512-.471-4.991-.976-7.373-1.5l.357-1.627c2.364.52,4.827,1.02,7.321,1.488Zm-14.695-3.24c-1.089-.28-2.182-.571-3.25-.866l-3.992-1.1.442-1.608,3.993,1.1c1.058.292,2.141.582,3.221.859Zm-14.47-3.951q-3.608-.985-7.231-1.962l.433-1.608q3.626.973,7.237,1.962Zm-181.236-.149-.884-1.412c2.123-1.331,4.315-2.609,6.516-3.8l.792,1.466C143.422,123.5,141.262,124.763,139.168,126.076Zm166.764-3.738c-2.495-.656-4.935-1.287-7.251-1.878l.41-1.614c2.322.591,4.765,1.225,7.265,1.881Zm-153.689-3.332-.7-1.513c2.264-1.042,4.6-2.03,6.947-2.936l.6,1.554C156.78,117,154.477,117.977,152.243,119.006Zm139.172-.362c-2.477-.608-4.926-1.194-7.281-1.743l.378-1.623c2.36.552,4.817,1.138,7.3,1.747Zm-14.584-3.4c-2.478-.546-4.941-1.067-7.321-1.551l.333-1.632c2.387.486,4.859,1.01,7.345,1.554Zm-110.722-1.6-.5-1.588c2.364-.751,4.8-1.447,7.249-2.068l.41,1.614C170.851,112.218,168.442,112.9,166.108,113.646Zm96.058-1.383c-2.489-.463-4.967-.9-7.368-1.3l.274-1.643c2.411.4,4.9.839,7.4,1.3Zm-81.635-2.293-.319-1.635c2.427-.476,4.928-.9,7.435-1.257l.236,1.649C185.4,109.082,182.932,109.5,180.531,109.971Zm66.876-.152c-2.5-.359-4.995-.687-7.412-.972l.2-1.655c2.431.289,4.938.618,7.453.979Zm-14.844-1.755c-2.512-.228-5.017-.419-7.45-.567l.1-1.664c2.451.149,4.973.342,7.5.571Zm-37.272-.213-.157-1.658c2.454-.232,4.981-.413,7.512-.541l.082,1.664C200.224,107.442,197.72,107.622,195.292,107.851Zm22.361-.685c-1.88-.052-3.762-.077-5.6-.077q-.937,0-1.867.009l-.017-1.665q.939-.009,1.884-.009c1.849,0,3.747.026,5.642.077Z",
    transform: "translate(-82.082 -105.423)",
    fill: "#c2bebc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2242",
    "data-name": "Group 2242",
    transform: "translate(498.762 141.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10053",
    "data-name": "Path 10053",
    d: "M451,173.269a48.251,48.251,0,0,0-5.165-12.452l5.257-7.907-7.294-7.3-7.3-7.3-7.909,5.257a48.336,48.336,0,0,0-12.452-5.165l-1.872-9.3H393.634l-1.872,9.3a48.336,48.336,0,0,0-12.452,5.165L371.4,138.32l-7.3,7.3-7.3,7.3,5.257,7.907a48.358,48.358,0,0,0-5.165,12.452l-9.3,1.874v20.633l9.3,1.872A48.313,48.313,0,0,0,362.07,210.1l-5.257,7.909,7.3,7.3,7.3,7.3,7.907-5.259a48.229,48.229,0,0,0,12.452,5.165l1.872,9.3h20.635l1.872-9.3a48.229,48.229,0,0,0,12.452-5.165L436.5,232.6l7.3-7.3,7.294-7.3-5.257-7.909A48.206,48.206,0,0,0,451,197.648l9.3-1.872V175.143Zm-47.048,48.34a36.15,36.15,0,1,1,36.152-36.15A36.148,36.148,0,0,1,403.95,221.609Z",
    transform: "translate(-347.603 -129.11)",
    fill: "#73c0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2243",
    "data-name": "Group 2243",
    transform: "translate(281.591 202.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3583",
    "data-name": "Rectangle 3583",
    d: "M12.479,0H261.039a12.479,12.479,0,0,1,12.479,12.479V183.9a12.479,12.479,0,0,1-12.479,12.479H12.478A12.478,12.478,0,0,1,0,183.9V12.479A12.479,12.479,0,0,1,12.479,0Z",
    fill: "#dae8f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2248",
    "data-name": "Group 2248",
    transform: "translate(299.49 214.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2244",
    "data-name": "Group 2244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10054",
    "data-name": "Path 10054",
    d: "M325.412,214.5a56.107,56.107,0,1,0-105.659,37.788c.424,1.187.886,2.355,1.381,3.5A56.108,56.108,0,0,0,325.412,214.5ZM286.749,273a42.015,42.015,0,0,1-52.739-22.821q-.556-1.286-1.036-2.623A42.066,42.066,0,1,1,286.749,273Z",
    transform: "translate(-216.459 -177.27)",
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2245",
    "data-name": "Group 2245",
    transform: "translate(2.561 0.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10055",
    "data-name": "Path 10055",
    d: "M231.55,220.848l-13.4-4.186a56.189,56.189,0,0,1,51.885-39.375l.418,14.037a42.134,42.134,0,0,0-38.9,29.524Z",
    transform: "translate(-218.145 -177.287)",
    fill: "#1a598c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2246",
    "data-name": "Group 2246",
    transform: "translate(0 39.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10056",
    "data-name": "Path 10056",
    d: "M234.01,236.711l-12.876,5.6c-.5-1.141-.957-2.31-1.381-3.5a55.86,55.86,0,0,1-.732-35.618l13.4,4.186a41.872,41.872,0,0,0,.549,26.7Q233.453,235.424,234.01,236.711Z",
    transform: "translate(-216.459 -203.2)",
    fill: "#2273b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2247",
    "data-name": "Group 2247",
    transform: "translate(4.675 72.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10057",
    "data-name": "Path 10057",
    d: "M228.234,244.825a55.8,55.8,0,0,1-8.7-13.967l12.876-5.6a41.9,41.9,0,0,0,6.519,10.474Z",
    transform: "translate(-219.536 -225.254)",
    fill: "#4da8f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2253",
    "data-name": "Group 2253",
    transform: "translate(300.073 333.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2249",
    "data-name": "Group 2249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10058",
    "data-name": "Path 10058",
    d: "M233.124,309.743a28.433,28.433,0,1,0,24.321-51.4c-.577-.273-1.162-.527-1.747-.76a28.435,28.435,0,0,0-22.574,52.163Zm-7.11-34.819a21.291,21.291,0,0,1,27.076-10.719q.661.258,1.311.567a21.318,21.318,0,1,1-28.387,10.152Z",
    transform: "translate(-216.843 -255.602)",
    fill: "#6eb2eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2250",
    "data-name": "Group 2250",
    transform: "translate(43.965 15.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10059",
    "data-name": "Path 10059",
    d: "M249.137,268.936l6.3-3.3a28.462,28.462,0,0,1-4.482,32.7l-5.18-4.879a21.355,21.355,0,0,0,3.36-24.517Z",
    transform: "translate(-245.777 -265.631)",
    fill: "#1a598c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2251",
    "data-name": "Group 2251",
    transform: "translate(36.248 1.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10060",
    "data-name": "Path 10060",
    d: "M240.7,263.529l2.607-6.625c.585.232,1.17.486,1.747.76a28.309,28.309,0,0,1,13.025,12.5l-6.3,3.3a21.21,21.21,0,0,0-9.766-9.374Q241.36,263.788,240.7,263.529Z",
    transform: "translate(-240.698 -256.904)",
    fill: "#2273b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2252",
    "data-name": "Group 2252",
    transform: "translate(30.159 0.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10061",
    "data-name": "Path 10061",
    d: "M237.264,255.662a28.388,28.388,0,0,1,8.123,1.887l-2.607,6.625a21.115,21.115,0,0,0-6.089-1.418Z",
    transform: "translate(-236.691 -255.662)",
    fill: "#4da8f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2254",
    "data-name": "Group 2254",
    transform: "translate(431.844 202.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10062",
    "data-name": "Path 10062",
    d: "M426.829,188.095V346.552a18.961,18.961,0,0,1-18.96,18.962H303.563V169.136H407.869A18.958,18.958,0,0,1,426.829,188.095Z",
    transform: "translate(-303.563 -169.136)",
    fill: "#4da8f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2255",
    "data-name": "Group 2255",
    transform: "translate(447.683 222.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3584",
    "data-name": "Rectangle 3584",
    d: "M1.627,0H89.96a1.628,1.628,0,0,1,1.628,1.628V8.351A1.628,1.628,0,0,1,89.96,9.979H1.628A1.628,1.628,0,0,1,0,8.351V1.627A1.627,1.627,0,0,1,1.627,0Z",
    fill: "#e3f2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2256",
    "data-name": "Group 2256",
    transform: "translate(447.683 244.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3585",
    "data-name": "Rectangle 3585",
    d: "M1.628,0H89.96a1.628,1.628,0,0,1,1.628,1.628V8.352a1.627,1.627,0,0,1-1.627,1.627H1.628A1.628,1.628,0,0,1,0,8.351V1.628A1.628,1.628,0,0,1,1.628,0Z",
    fill: "#73c0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2257",
    "data-name": "Group 2257",
    transform: "translate(447.683 268.562)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3586",
    "data-name": "Rectangle 3586",
    width: 91.588,
    height: 112.837,
    rx: 5.474,
    transform: "translate(0 0)",
    fill: "#73c0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2258",
    "data-name": "Group 2258",
    transform: "translate(441.723 263.762)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3587",
    "data-name": "Rectangle 3587",
    d: "M6.728,0H25.794a6.729,6.729,0,0,1,6.729,6.729V76.9A6.728,6.728,0,0,1,25.8,83.629H6.728A6.728,6.728,0,0,1,0,76.9V6.728A6.728,6.728,0,0,1,6.728,0Z",
    transform: "translate(0 0)",
    fill: "#e0f1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2259",
    "data-name": "Group 2259",
    transform: "translate(229.928 193.162)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3588",
    "data-name": "Rectangle 3588",
    width: 209.022,
    height: 1.388,
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2260",
    "data-name": "Group 2260",
    transform: "translate(239.657 159.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10063",
    "data-name": "Path 10063",
    d: "M188.287,163.272a11.2,11.2,0,1,1,11.2-11.2A11.217,11.217,0,0,1,188.287,163.272Zm0-20.741a9.538,9.538,0,1,0,9.536,9.538A9.548,9.548,0,0,0,188.287,142.531Z",
    transform: "translate(-177.082 -140.864)",
    fill: "#4da8f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2262",
    "data-name": "Group 2262",
    transform: "translate(207.04 309.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2261",
    "data-name": "Group 2261",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10064",
    "data-name": "Path 10064",
    d: "M169.411,239.643s10.465,1.869,10.557,10.732-8.015,21.7-13.286,20.749-11.264-5.628-11.06-11.019,1.7-12.475,4.127-16.362S166.486,239.452,169.411,239.643Z",
    transform: "translate(-155.617 -239.605)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2264",
    "data-name": "Group 2264",
    transform: "translate(207.343 308.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2263",
    "data-name": "Group 2263",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10065",
    "data-name": "Path 10065",
    d: "M155.883,256.218s.02,1.808,3.619,3.24,10.213-.573,11.873-.24,2.152-.468,2.152-.468l.115,1.769,1.407.956s.986-4.709,3.943-5.119,5.422-13.925-7.329-16.482c0,0-9.439-2.565-11.873,2.226S155.427,252.844,155.883,256.218Z",
    transform: "translate(-155.816 -239.187)",
    fill: "#e8734d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2265",
    "data-name": "Group 2265",
    transform: "translate(191.156 373.321)",
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3589",
    "data-name": "Rectangle 3589",
    d: "M8.054,0H98.423a8.055,8.055,0,0,1,8.055,8.055V98.423a8.055,8.055,0,0,1-8.055,8.055H8.054A8.054,8.054,0,0,1,0,98.423V8.054A8.054,8.054,0,0,1,8.054,0Z",
    transform: "translate(0)",
    fill: "#87c9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2266",
    "data-name": "Group 2266",
    transform: "translate(182.904 202.234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3590",
    "data-name": "Rectangle 3590",
    width: 106.479,
    height: 80.871,
    rx: 7.02,
    fill: "#e3f2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2267",
    "data-name": "Group 2267",
    transform: "translate(248.144 388.971)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3591",
    "data-name": "Rectangle 3591",
    width: 41.359,
    height: 11.454,
    rx: 1.646,
    transform: "translate(0 0)",
    fill: "#e3f2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2268",
    "data-name": "Group 2268",
    transform: "translate(248.144 406.247)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3592",
    "data-name": "Rectangle 3592",
    width: 41.359,
    height: 60.704,
    rx: 3.79,
    transform: "translate(0 0)",
    fill: "#e3f2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2274",
    "data-name": "Group 2274",
    transform: "translate(202.156 384.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2269",
    "data-name": "Group 2269",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10066",
    "data-name": "Path 10066",
    d: "M165.327,325.951a19.026,19.026,0,0,0,25.128-17.781c.006-.428,0-.854-.024-1.275a19.028,19.028,0,1,0-25.1,19.056Zm-8.164-18.21a14.269,14.269,0,0,1,27.679-4.688v.008a14.213,14.213,0,0,1,.833,4.092q.023.472.018.956a14.267,14.267,0,1,1-28.531-.368Z",
    transform: "translate(-152.402 -288.897)",
    fill: "#e3f2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2270",
    "data-name": "Group 2270",
    transform: "translate(12.925 27.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10067",
    "data-name": "Path 10067",
    d: "M178.289,307.168l3.765,2.917a19.055,19.055,0,0,1-21.147,6.376l1.527-4.511a14.289,14.289,0,0,0,15.854-4.782Z",
    transform: "translate(-160.908 -307.168)",
    fill: "#1a598c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2271",
    "data-name": "Group 2271",
    transform: "translate(30.306 17.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10068",
    "data-name": "Path 10068",
    d: "M175.313,301l4.756-.258c.021.422.03.848.024,1.276a18.943,18.943,0,0,1-3.981,11.407l-3.765-2.917a14.2,14.2,0,0,0,2.984-8.55C175.337,301.634,175.33,301.315,175.313,301Z",
    transform: "translate(-172.347 -300.741)",
    fill: "#2273b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2272",
    "data-name": "Group 2272",
    transform: "translate(32.44 12.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10069",
    "data-name": "Path 10069",
    d: "M174.585,302.87a14.214,14.214,0,0,0-.833-4.092l0-.008,4.475-1.627a18.924,18.924,0,0,1,1.114,5.469Z",
    transform: "translate(-173.751 -297.143)",
    fill: "#2273b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2273",
    "data-name": "Group 2273",
    transform: "translate(7.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10070",
    "data-name": "Path 10070",
    d: "M157.392,292.725a19.03,19.03,0,0,1,29.332,8.7l-4.473,1.635,0-.008a14.267,14.267,0,0,0-22.066-6.47Z",
    transform: "translate(-157.392 -288.897)",
    fill: "#4da8f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2278",
    "data-name": "Group 2278",
    transform: "translate(80.984 202.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2275",
    "data-name": "Group 2275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10071",
    "data-name": "Path 10071",
    d: "M72.657,205.1l22.936-35.835-11.649,5.282Z",
    transform: "translate(-72.657 -169.266)",
    fill: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2276",
    "data-name": "Group 2276",
    transform: "translate(0 9.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10072",
    "data-name": "Path 10072",
    d: "M72.657,201.857l1.4-21.6,8.332-4.75Z",
    transform: "translate(-72.657 -175.51)",
    fill: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2277",
    "data-name": "Group 2277",
    transform: "translate(0 8.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10073",
    "data-name": "Path 10073",
    d: "M90.318,174.69l2.865,3.775L72.657,202.284Z",
    transform: "translate(-72.657 -174.69)",
    fill: "#c2c2c2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2279",
    "data-name": "Group 2279",
    transform: "translate(239.148 374.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10074",
    "data-name": "Path 10074",
    d: "M177.934,286.752a3.165,3.165,0,0,0,1.623-.742c1.03-1.051,1.126-3.27,3.2-3.42s3.989,6.14,3.656,7.433-3.088,2.331-7.423,2.121S177.934,286.752,177.934,286.752Z",
    transform: "translate(-176.747 -282.587)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2280",
    "data-name": "Group 2280",
    transform: "translate(244.395 370.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10075",
    "data-name": "Path 10075",
    d: "M180.267,284.129a64.769,64.769,0,0,1,6.09-2.691c2.889-1.092,6.461-1.869,6.848-1.372.863,1.1-2.507,1.881-5.308,3.15-2.579,1.169-2.135.98-2.135.98s-.191-.062,2.84-.81c3.261-.8,6.668-1.307,7.1-.7.211.3.591,1.333-.776,1.29.711-.14.6-.248.67.035.365,1.468-4.28,3.376-6.125,4.133,1.421-.573,2.516-.848,2.135.229-.435,1.234-7.11,3.645-9.428,4.73C179.65,294.288,180.267,284.129,180.267,284.129Z",
    transform: "translate(-180.2 -279.912)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2281",
    "data-name": "Group 2281",
    transform: "translate(155.969 335.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10076",
    "data-name": "Path 10076",
    d: "M160.937,256.878a79.145,79.145,0,0,0-11.153,0c-4.616.471-10.992,4.249-14.852,5.338s-13.174,7.35-12.922,8.207a69.585,69.585,0,0,0,10.53,19.316C138.25,296.819,160.937,256.878,160.937,256.878Z",
    transform: "translate(-122.006 -256.667)",
    fill: "#d4d8e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2282",
    "data-name": "Group 2282",
    transform: "translate(167.994 339.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10077",
    "data-name": "Path 10077",
    d: "M142.716,259.507s-7.049,5.218-9.5,10a38.7,38.7,0,0,0-3.291,10.478Z",
    transform: "translate(-129.92 -259.507)",
    fill: "#a9adba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2283",
    "data-name": "Group 2283",
    transform: "translate(173.172 494.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10078",
    "data-name": "Path 10078",
    d: "M146.288,361.991a17.145,17.145,0,0,0,3.179,2.706c1.164.567,15.07,2.958,16.015,4.09s.944,5.6-2.644,5.6-15.543-.064-17.558,0-10.519,1.763-11.395,0-.795-9.985.76-11.955S146.288,361.991,146.288,361.991Z",
    transform: "translate(-133.327 -361.426)",
    fill: "#1c4154"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2284",
    "data-name": "Group 2284",
    transform: "translate(174.49 492.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10079",
    "data-name": "Path 10079",
    d: "M145.409,360.154l.429,2.5s-3.712,1.7-11.642.442v-2.582Z",
    transform: "translate(-134.195 -360.154)",
    fill: "#2a617d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2285",
    "data-name": "Group 2285",
    transform: "translate(96.843 488.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10080",
    "data-name": "Path 10080",
    d: "M87.5,357.243a13.767,13.767,0,0,0-2.329,4.154c-.492,1.5-2.831,8.5-1.825,10.194s8.936,1.951,12.9,1.322,12.586.691,13.467-1.006,1.386-4.179-1.2-5.142-8.5-3.481-9.565-6.124S87.5,357.243,87.5,357.243Z",
    transform: "translate(-83.094 -357.243)",
    fill: "#1c4154"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2286",
    "data-name": "Group 2286",
    transform: "translate(101.246 482.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10081",
    "data-name": "Path 10081",
    d: "M98.545,359.6l-1.1,2.832s-11.358-.852-11.452-3.4l3.586-5.223Z",
    transform: "translate(-85.992 -353.806)",
    fill: "#2a617d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2289",
    "data-name": "Group 2289",
    transform: "translate(198.664 330.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2288",
    "data-name": "Group 2288",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2287",
    "data-name": "Group 2287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10082",
    "data-name": "Path 10082",
    d: "M158.5,253.632s-6.332,5.377-8.134,4.938,6.21,11.375,6.21,11.375,7.628-7.508,9.346-7.736S158.5,253.632,158.5,253.632Z",
    transform: "translate(-150.104 -253.632)",
    fill: "#eea886"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290",
    transform: "translate(205.157 348.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10083",
    "data-name": "Path 10083",
    d: "M156.712,268.588c-2.156,1.3-2.518,1.722-2.266,7.889s2.811,11.138,3,12.837,3.615,18.553,4.558,19.5,12.226-1.255,14.508-1.962c3.416-1.059,17.872-5.955,17.872-5.955l-3.18-6.631s-18.249,4.071-18.837,2.644-2.015-13.4-2.519-16.006.374-6.689-2.734-12.859C164.331,262.516,156.712,268.588,156.712,268.588Z",
    transform: "translate(-154.377 -265.719)",
    fill: "#d4d8e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2291",
    "data-name": "Group 2291",
    transform: "translate(149.468 384.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10084",
    "data-name": "Path 10084",
    d: "M154.352,302.963s3.869,4.115,4.951,5.452c7.409,9.156,17.494,25.97,18.754,28.907s-6.234,23.7-9.313,30.96c-1.615,3.806-12.293,30.019-11.957,30.606s-11.3.976-16.5-1.709c0,0,7.48-22.159,9.055-26.5,2.381-6.561,10.63-24.734,10.883-26.5s-13.338-16.293-17.869-19.062-15.605-12.586-16.865-13.846-8.391-4.615-7.719-10.992,5.411-11.41,5.411-11.41Z",
    transform: "translate(-117.728 -288.868)",
    fill: "#326ea0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2292",
    "data-name": "Group 2292",
    transform: "translate(102.442 383.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10085",
    "data-name": "Path 10085",
    d: "M150.1,319.1s-.708,1.863-1.7,4.475c-2.135,5.6-5.583,14.651-6.157,16.082-.837,2.1-5.034,11.159-7.047,12.923s-35.155,41.532-35.242,41.867-12.417-6.041-13.171-8.476c0,0,17.954-23.409,20.723-26.848s8.559-8.558,10.489-16.7,15.771-39.435,15.813-40.611c0,0,2.228-9.647,5.457-12.584s14.978.5,16.824,6.628S150.1,319.1,150.1,319.1Z",
    transform: "translate(-86.779 -288.167)",
    fill: "#326ea0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2293",
    "data-name": "Group 2293",
    transform: "translate(198.355 334.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10086",
    "data-name": "Path 10086",
    d: "M149.9,257.206l2.676-1.056s6.754,1.553,10.655,6.964l-.334,1.618S152.6,262.5,149.9,257.206Z",
    transform: "translate(-149.901 -256.15)",
    fill: "#d4d8e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2294",
    "data-name": "Group 2294",
    transform: "translate(206.459 366.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10087",
    "data-name": "Path 10087",
    d: "M157.443,285.519a10.633,10.633,0,0,1-1.261,1.541c-.191.166-.422.359-.69.576l0,0-.254-10.15s1.273,3.913,1.462,4.49S157.443,285.519,157.443,285.519Z",
    transform: "translate(-155.234 -277.488)",
    fill: "#a9adba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2295",
    "data-name": "Group 2295",
    transform: "translate(156.656 406.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10088",
    "data-name": "Path 10088",
    d: "M131.563,311.238s-.708,1.863-1.7,4.475c-2.255-2.6-7.4-12.408-7.4-12.408.336.24,1.413,1.251,1.662,1.474S131.563,311.238,131.563,311.238Z",
    transform: "translate(-122.458 -303.305)",
    fill: "#215b8a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2297",
    "data-name": "Group 2297",
    transform: "translate(219.662 325.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2296",
    "data-name": "Group 2296",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10089",
    "data-name": "Path 10089",
    d: "M167.661,252.714c.239-.769-.336-3.708-2.212-2.035s-1.867,5.422-.808,5.727S167.059,254.663,167.661,252.714Z",
    transform: "translate(-163.923 -250.172)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2299",
    "data-name": "Group 2299",
    transform: "translate(207.257 310.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2298",
    "data-name": "Group 2298",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10090",
    "data-name": "Path 10090",
    d: "M164.89,241.289s-9.08-6.456-9.131,15.561Z",
    transform: "translate(-155.759 -240.406)",
    fill: "#e8734d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2300",
    "data-name": "Group 2300",
    transform: "translate(154.924 335.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10091",
    "data-name": "Path 10091",
    d: "M175.062,296.267a10.638,10.638,0,0,1-1.261,1.541c-.191.166-.422.359-.69.576l0,0a105.846,105.846,0,0,1-10.968,7.476c-2.937,1.6-8.506,15.031-8.506,15.031s-26.274-1.773-32.315-15.365c0,0,4.28-9.565,8.182-15.228s12.458-26.055,16.989-28.948,8.433-4.783,17.369-4.531,13.887,7.342,13.887,7.342,6.8,7.3,7.467,11.159C185.79,278.642,178.413,291.6,175.062,296.267Z",
    transform: "translate(-121.318 -256.798)",
    fill: "#d4d8e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2301",
    "data-name": "Group 2301",
    transform: "translate(182.72 202.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10092",
    "data-name": "Path 10092",
    d: "M246.275,179.8l-.185,5.921H139.611l.184-5.921a10.666,10.666,0,0,1,10.667-10.667h85.146A10.665,10.665,0,0,1,246.275,179.8Z",
    transform: "translate(-139.611 -169.136)",
    fill: "#4da8f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2302",
    "data-name": "Group 2302",
    transform: "translate(189.86 223.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10093",
    "data-name": "Path 10093",
    d: "M170.754,235.908H149.33a5.026,5.026,0,0,1-5.02-5.02V188.179a5.026,5.026,0,0,1,5.02-5.02h21.423a5.027,5.027,0,0,1,5.022,5.02v42.708A5.027,5.027,0,0,1,170.754,235.908ZM149.33,184.824a3.359,3.359,0,0,0-3.355,3.355v42.708a3.358,3.358,0,0,0,3.355,3.355h21.423a3.358,3.358,0,0,0,3.355-3.355V188.179a3.359,3.359,0,0,0-3.355-3.355Z",
    transform: "translate(-144.31 -183.159)",
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2303",
    "data-name": "Group 2303",
    transform: "translate(227.008 224.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3593",
    "data-name": "Rectangle 3593",
    width: 54.377,
    height: 4.442,
    rx: 1.098,
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2304",
    "data-name": "Group 2304",
    transform: "translate(227.008 233.398)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3594",
    "data-name": "Rectangle 3594",
    width: 54.377,
    height: 4.442,
    rx: 1.098,
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2305",
    "data-name": "Group 2305",
    transform: "translate(367.368 339.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3595",
    "data-name": "Rectangle 3595",
    d: "M1.7,0H37.17a1.7,1.7,0,0,1,1.7,1.7V8.668a1.7,1.7,0,0,1-1.7,1.7H1.7A1.7,1.7,0,0,1,0,8.667V1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(0 0)",
    fill: "#6eb2eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2306",
    "data-name": "Group 2306",
    transform: "translate(367.368 356.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3596",
    "data-name": "Rectangle 3596",
    d: "M1.7,0H37.17a1.7,1.7,0,0,1,1.7,1.7V8.666a1.7,1.7,0,0,1-1.7,1.7H1.7A1.7,1.7,0,0,1,0,8.665V1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(0 0)",
    fill: "#4da8f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2307",
    "data-name": "Group 2307",
    transform: "translate(367.368 373.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3597",
    "data-name": "Rectangle 3597",
    d: "M1.7,0H37.17a1.7,1.7,0,0,1,1.7,1.7V8.666a1.7,1.7,0,0,1-1.7,1.7H1.7A1.7,1.7,0,0,1,0,8.665V1.7A1.7,1.7,0,0,1,1.7,0Z",
    transform: "translate(0 0)",
    fill: "#2273b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2308",
    "data-name": "Group 2308",
    transform: "translate(190.693 206.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10094",
    "data-name": "Path 10094",
    d: "M154.113,176.641a4.628,4.628,0,1,1-4.628-4.627A4.628,4.628,0,0,1,154.113,176.641Z",
    transform: "translate(-144.858 -172.014)",
    fill: "#e3f2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2310",
    "data-name": "Group 2310",
    transform: "translate(548.009 343.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2309",
    "data-name": "Group 2309",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10095",
    "data-name": "Path 10095",
    d: "M380.013,289.7s18.811,6.07,23.152,5c2.3-.567,5.885-3.821,9.22-7.332.552-.582,1.1-1.172,1.629-1.753,3.677-4.046,6.681-7.9,6.681-7.9s9.111-10.679,1.8-15.438a9.777,9.777,0,0,0-5.665,2.916,37.365,37.365,0,0,0-5.362,8.169c-.638,1.393-9.586,14.3-10.051,14.59s-4.373-.738-7.508-1c-5.113-.427-12.762-3.033-12.762-3.033Z",
    transform: "translate(-380.013 -262.28)",
    fill: "#2273b5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2311",
    "data-name": "Group 2311",
    transform: "translate(558.849 487.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10096",
    "data-name": "Path 10096",
    d: "M402.164,356.6s-2.393,4.282-3.815,5.15c-1.772,1.08-5.21,4.549-6.412,4.71s-5.517.925-4.683,3.363c.682,2,10.98,1.711,12.141.71s4.634-4.593,6.037-4.513.881,5.181.881,5.181h1.521s.53-4.964.594-5.818c.19-2.525-1.609-4.385-1.69-5.826s-.163-2.516-.163-2.516Z",
    transform: "translate(-387.147 -356.596)",
    fill: "#16202e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312",
    transform: "translate(563.983 486.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10097",
    "data-name": "Path 10097",
    d: "M390.526,366.429s3.395,1.171,6.007-.33,7.626-3.78,9.4-3.8c0,0-.968-2.957-.986-3.288s-.126-1.887-.126-1.887l-4.384-.7s-2.843,4.174-4.1,5.157A70.938,70.938,0,0,0,390.526,366.429Z",
    transform: "translate(-390.526 -356.423)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313",
    transform: "translate(611.093 490.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10098",
    "data-name": "Path 10098",
    d: "M425.69,359.612a18.482,18.482,0,0,1-.886,3.771c-.462.808-1.732,4.928-2.31,5.7s-1.848,6.543,0,7.234,6.2,1.848,7.658-.46a9.506,9.506,0,0,0,1.425-6.389c-.233-1.77-1.988-9.895-1.963-10.7S425.69,359.612,425.69,359.612Z",
    transform: "translate(-421.53 -358.544)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2314",
    "data-name": "Group 2314",
    transform: "translate(610.533 498.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10099",
    "data-name": "Path 10099",
    d: "M423.423,364.426s-.2,4.484,3.188,4.484,4.888-4.081,4.888-4.081,1.155,2,0,6.274-5.966,3.388-7.043,3.233S418.272,372.832,423.423,364.426Z",
    transform: "translate(-421.161 -364.426)",
    fill: "#16202e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2315",
    "data-name": "Group 2315",
    transform: "translate(585.081 387.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10100",
    "data-name": "Path 10100",
    d: "M428.995,292.658s4.379,5.58,5.923,9.27,4.119,11.781,3.777,18.049-2.4,18.026-1.8,20.686,1.2,8.154,1.846,10.042,3.218,7.383,3.477,13.046-1.832,30.517-1.662,32.835-7.5.9-7.5.9-.2-22.4-1.055-26.266-1.889-17-2.662-17.942-2.939-10.9-3.078-12.527c-.135-1.573-9.319-28.8-9.833-33.432s-12.015-14.663-12.015-14.663A40.126,40.126,0,0,1,428.995,292.658Z",
    transform: "translate(-404.411 -290.74)",
    fill: "#1a598c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2316",
    "data-name": "Group 2316",
    transform: "translate(572.802 385.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10101",
    "data-name": "Path 10101",
    d: "M404.671,392.53c1.633-.257,6-25.365,5.487-29.829s-1.03-13.979.43-17.848c.957-2.539,6.94-15.455,10.966-24.525.567-1.281,1.1-2.483,1.567-3.571a40.3,40.3,0,0,0,2.144-5.472c.088-1.717,5.683-31.289-16.429-18.134a26.412,26.412,0,0,1-.48,3.2c-.26.857-6.181,22.747-6.781,31.159a166.173,166.173,0,0,1-2.4,17.345,37.226,37.226,0,0,0,.772,9.352c.515,1.544-3.349,36.428-3.606,37.288S403.042,392.786,404.671,392.53Z",
    transform: "translate(-396.329 -289.789)",
    fill: "#1a598c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2318",
    "data-name": "Group 2318",
    transform: "translate(579.878 341.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2317",
    "data-name": "Group 2317",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10102",
    "data-name": "Path 10102",
    d: "M415.091,261.326a43.764,43.764,0,0,1-5.637,2.266c-1.453.29-7.09,7.611-8.081,10.284s0,6.681,2.032,11.389.114,6.277,1.044,10.983a109.541,109.541,0,0,1,1.565,17.286c-.175,2.615,23.5,3.115,28.905-1.649,0,0-5.428-8.135-6.125-9.3s-.114-7.5.526-9.123,5.169-15.067,5.169-15.067,3.209-11.021.065-13.463c-2.731-2.12-10.173-2.879-11.509-3.343A22.8,22.8,0,0,0,415.091,261.326Z",
    transform: "translate(-400.987 -261.109)",
    fill: "#eddad3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2320",
    "data-name": "Group 2320",
    transform: "translate(590.102 340.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2319",
    "data-name": "Group 2319",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10103",
    "data-name": "Path 10103",
    d: "M410.256,271.087l-2.541-2.977,2.209-7.838A51.746,51.746,0,0,1,410.256,271.087Z",
    transform: "translate(-407.715 -260.273)",
    fill: "#d6c5be"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2322",
    "data-name": "Group 2322",
    transform: "translate(591.986 331.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2321",
    "data-name": "Group 2321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10104",
    "data-name": "Path 10104",
    d: "M408.955,260.031a100.239,100.239,0,0,1,.66,10.176s4.344,4.358,9.292-5.083a12.976,12.976,0,0,1-.514-9.2C419.961,250.626,408.955,260.031,408.955,260.031Z",
    transform: "translate(-408.955 -254.308)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2324",
    "data-name": "Group 2324",
    transform: "translate(592.642 347.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2323",
    "data-name": "Group 2323",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10105",
    "data-name": "Path 10105",
    d: "M409.39,264.771l0,3.98,5.005-3.736Z",
    transform: "translate(-409.387 -264.771)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2326",
    "data-name": "Group 2326",
    transform: "translate(592.642 341.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2325",
    "data-name": "Group 2325",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10106",
    "data-name": "Path 10106",
    d: "M409.387,270.652l2.079-2.57,7-6.973,2.264,2.181Z",
    transform: "translate(-409.387 -261.109)",
    fill: "#d6c5be"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2328",
    "data-name": "Group 2328",
    transform: "translate(596.513 342.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2327",
    "data-name": "Group 2327",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10107",
    "data-name": "Path 10107",
    d: "M416.1,317.015c1.969,9.431,16.222-1.061,16.222-1.061s-9.24-15.529-5.564-27.94c.029-.1.058-.2.088-.293q.351-1.176.7-2.24c.041-.128.084-.257.125-.381.8-2.44,1.459-4.458,1.989-6.117v0c1.644-5.109,2.12-6.791,2.12-6.791s-.7-7.952-4.63-8.824c-3.943-.875-8.108-1.7-8.108-1.7s-6.807,8.729-7.09,12.653S414.131,307.581,416.1,317.015Z",
    transform: "translate(-411.934 -261.667)",
    fill: "#2273b5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2330",
    "data-name": "Group 2330",
    transform: "translate(579.665 343.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2329",
    "data-name": "Group 2329",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M400.863,275.137s-.441,5.408,3.273,12.51c0,0-.079,9.509-.2,12.82s-.906,15.835-.906,15.835l4.081,2.392a1.149,1.149,0,0,0,1.723-1.132c-1.152-9.53-4.9-45.687,3.221-55.4l-3.62,1.251S400.863,271.354,400.863,275.137Z",
    transform: "translate(-400.846 -262.157)",
    fill: "#2273b5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2332",
    "data-name": "Group 2332",
    transform: "translate(586.898 340.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2331",
    "data-name": "Group 2331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M408.81,268.11l-3.2.883,5.413-8.721Z",
    transform: "translate(-405.606 -260.273)",
    fill: "#fae6de"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2334",
    "data-name": "Group 2334",
    transform: "translate(594.721 341.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2333",
    "data-name": "Group 2333",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10110",
    "data-name": "Path 10110",
    d: "M410.755,268.082l2.925,3.836,5.98-9.961-1.907-.847Z",
    transform: "translate(-410.755 -261.109)",
    fill: "#fae6de"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2335",
    "data-name": "Group 2335",
    transform: "translate(583.231 312.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10111",
    "data-name": "Path 10111",
    d: "M414.977,241.785a10.4,10.4,0,0,0-11.375,9.008,25.283,25.283,0,0,0,.593,3.952c.448,1.747-1.336,6.753-.945,7.023a11.16,11.16,0,0,0,2.039.669s1.527,5.633,3.477,5.678,9.4-1.127,13.2-7.865S427.341,242.974,414.977,241.785Z",
    transform: "translate(-403.193 -241.746)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2336",
    "data-name": "Group 2336",
    transform: "translate(583.62 311.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10112",
    "data-name": "Path 10112",
    d: "M403.469,251.225s4.82,3.633,9.729,4.554,7.569,9.465,7.569,9.465S429,252.864,423.3,244.937,402.844,241.694,403.469,251.225Z",
    transform: "translate(-403.449 -240.915)",
    fill: "#344052"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2337",
    "data-name": "Group 2337",
    transform: "translate(595.249 324.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10113",
    "data-name": "Path 10113",
    d: "M411.29,251.138a1.523,1.523,0,0,1,2.712-.957c1.506,1.381-.819,5.83-2.083,5.324S411.216,252.127,411.29,251.138Z",
    transform: "translate(-411.102 -249.596)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2338",
    "data-name": "Group 2338",
    transform: "translate(591.975 335.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10114",
    "data-name": "Path 10114",
    d: "M408.948,259.936c.112.6.225,1.293.318,2.033a21.382,21.382,0,0,0,6.282-5.342A24.3,24.3,0,0,1,408.948,259.936Z",
    transform: "translate(-408.948 -256.627)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2339",
    "data-name": "Group 2339",
    transform: "translate(498.317 337.477)",
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10115",
    "data-name": "Path 10115",
    d: "M353.336,311.018l61.09.3a6.057,6.057,0,0,0,6.087-6.026l.2-40.762a6.059,6.059,0,0,0-6.028-6.089l-61.09-.3a6.057,6.057,0,0,0-6.087,6.026l-.2,40.763A6.058,6.058,0,0,0,353.336,311.018Z",
    transform: "translate(-347.31 -258.141)",
    fill: "#e0f1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2340",
    "data-name": "Group 2340",
    transform: "translate(527.591 343.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10116",
    "data-name": "Path 10116",
    d: "M370.528,304.8l31.134.155A3.975,3.975,0,0,0,405.654,301l.17-34.629a3.973,3.973,0,0,0-3.951-3.99l-31.136-.152a3.968,3.968,0,0,0-3.99,3.951l-.172,34.626A3.97,3.97,0,0,0,370.528,304.8Z",
    transform: "translate(-366.576 -262.231)",
    fill: "#a1d4ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2341",
    "data-name": "Group 2341",
    transform: "translate(505.042 379.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3598",
    "data-name": "Rectangle 3598",
    d: "M.735,0H19.494a.734.734,0,0,1,.734.734V5.762a.735.735,0,0,1-.735.735H.735A.735.735,0,0,1,0,5.761V.735A.735.735,0,0,1,.735,0Z",
    transform: "translate(20.227 6.597) rotate(-179.716)",
    fill: "#a1d4ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2342",
    "data-name": "Group 2342",
    transform: "translate(505.057 375.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10117",
    "data-name": "Path 10117",
    d: "M352.351,285.328l19.012.093a.606.606,0,0,0,.611-.6l0-.708a.609.609,0,0,0-.6-.611l-19.013-.094a.606.606,0,0,0-.609.6l0,.71A.606.606,0,0,0,352.351,285.328Z",
    transform: "translate(-351.746 -283.404)",
    fill: "#a1d4ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2345",
    "data-name": "Group 2345",
    transform: "translate(559.486 371.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2343",
    "data-name": "Group 2343",
    transform: "translate(9.175 0.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10118",
    "data-name": "Path 10118",
    d: "M398.919,282.444a2.262,2.262,0,0,1-1.273-.091c-.954-.445-1.574-1.908-3-1.489s-1.135,5.112-.588,5.9,2.653.786,5.5-.438S398.919,282.444,398.919,282.444Z",
    transform: "translate(-393.605 -280.789)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2344",
    "data-name": "Group 2344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10119",
    "data-name": "Path 10119",
    d: "M398.284,280.884a46.269,46.269,0,0,0-4.753-.278c-2.209-.009-4.765.377-4.932.795-.187.467,2.218.324,4.413.473,2.018.137,1.609.433,1.609.433s.111-.091-2.108.167c-2.386.278-4.793.792-4.931,1.31-.068.252.044.389.933.425-.512.082-.555.229-.53.438.123,1.074,3.712,1.19,5.137,1.234-1.1-.027-1.9.062-1.374.688.6.717,5.677.661,7.5.808C401.241,287.535,398.284,280.884,398.284,280.884Z",
    transform: "translate(-387.566 -280.606)",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2346",
    "data-name": "Group 2346",
    transform: "translate(599.308 319.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10120",
    "data-name": "Path 10120",
    d: "M414.5,251.006c-1.506,3.426-.6,7.142,2.033,8.295s5.979-.685,7.485-4.112.594-7.14-2.033-8.3S416,247.581,414.5,251.006Z",
    transform: "translate(-413.774 -246.549)",
    fill: "#344052"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2348",
    "data-name": "Group 2348",
    transform: "translate(573.591 344.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2347",
    "data-name": "Group 2347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10121",
    "data-name": "Path 10121",
    d: "M435.792,262.98s-3.9.717-5.826,3.726a42.818,42.818,0,0,0-4.279,8.769c-.377,1.486-7.689,15.117-8.094,15.487s-4.437.061-7.566.368c-5.107.5-13.1-.688-13.1-.688l-.079,5.888s19.6,2.591,23.677.757c4.987-2.241,17.055-19.1,17.055-19.1S443.841,266.346,435.792,262.98Z",
    transform: "translate(-396.849 -262.98)",
    fill: "#2273b5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2349",
    "data-name": "Group 2349",
    transform: "translate(604.616 360.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10122",
    "data-name": "Path 10122",
    d: "M417.267,285.3l7.638-6.117c.8-2.44,1.459-4.458,1.989-6.117C426.895,273.062,419.153,283.2,417.267,285.3Z",
    transform: "translate(-417.267 -273.062)",
    fill: "#1a598c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2350",
    "data-name": "Group 2350",
    transform: "translate(579.693 359.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10123",
    "data-name": "Path 10123",
    d: "M401.553,282.071c.552-.582,1.1-1.172,1.629-1.753,0,0-2.071-5.5-2.206-7.833A34.079,34.079,0,0,0,401.553,282.071Z",
    transform: "translate(-400.865 -272.485)",
    fill: "#1a598c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2355",
    "data-name": "Group 2355",
    transform: "translate(505.062 342.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2351",
    "data-name": "Group 2351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10124",
    "data-name": "Path 10124",
    d: "M369.1,267.554a8.937,8.937,0,1,0-16.83,6.019c.068.188.14.375.22.558a8.937,8.937,0,0,0,16.61-6.576Zm-6.159,9.318a6.7,6.7,0,0,1-8.4-3.633c-.059-.138-.114-.278-.166-.419a6.7,6.7,0,1,1,8.565,4.052Z",
    transform: "translate(-351.749 -261.624)",
    fill: "#73c0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2352",
    "data-name": "Group 2352",
    transform: "translate(0.409 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10125",
    "data-name": "Path 10125",
    d: "M354.153,268.565l-2.135-.667a8.952,8.952,0,0,1,8.263-6.271l.067,2.237a6.711,6.711,0,0,0-6.195,4.7Z",
    transform: "translate(-352.018 -261.627)",
    fill: "#73c0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2353",
    "data-name": "Group 2353",
    transform: "translate(0 6.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10126",
    "data-name": "Path 10126",
    d: "M354.545,271.094l-2.051.892c-.081-.182-.152-.369-.22-.558a8.9,8.9,0,0,1-.116-5.674l2.135.667a6.682,6.682,0,0,0,.087,4.253C354.431,270.815,354.486,270.955,354.545,271.094Z",
    transform: "translate(-351.749 -265.754)",
    fill: "#73c0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2354",
    "data-name": "Group 2354",
    transform: "translate(0.745 11.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10127",
    "data-name": "Path 10127",
    d: "M353.625,272.383a8.881,8.881,0,0,1-1.386-2.223l2.051-.892a6.64,6.64,0,0,0,1.038,1.665Z",
    transform: "translate(-352.239 -269.268)",
    fill: "#73c0ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2360",
    "data-name": "Group 2360",
    transform: "translate(505.225 361.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2356",
    "data-name": "Group 2356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10128",
    "data-name": "Path 10128",
    d: "M358.984,276.683a3.673,3.673,0,0,0-3.566-2.434,3.62,3.62,0,0,0-1.126.214,3.671,3.671,0,0,0-2.22,4.692c.027.076.056.153.09.228a3.671,3.671,0,0,0,6.823-2.7Zm-2.53,3.826A2.754,2.754,0,0,1,353,279.017c-.023-.055-.046-.114-.067-.172a2.752,2.752,0,1,1,3.518,1.664Z",
    transform: "translate(-351.856 -274.247)",
    fill: "#73c0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2357",
    "data-name": "Group 2357",
    transform: "translate(0.168 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10129",
    "data-name": "Path 10129",
    d: "M352.844,277.1l-.877-.274a3.657,3.657,0,0,1,2.267-2.361,3.617,3.617,0,0,1,1.126-.214l.027.919a2.742,2.742,0,0,0-2.544,1.93Z",
    transform: "translate(-351.967 -274.248)",
    fill: "#73c0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2358",
    "data-name": "Group 2358",
    transform: "translate(0 2.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10130",
    "data-name": "Path 10130",
    d: "M353,278.136l-.842.366c-.033-.074-.062-.152-.09-.228a3.651,3.651,0,0,1-.047-2.331l.877.273a2.735,2.735,0,0,0,.035,1.747C352.957,278.022,352.98,278.081,353,278.136Z",
    transform: "translate(-351.856 -275.943)",
    fill: "#73c0ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2359",
    "data-name": "Group 2359",
    transform: "translate(0.305 4.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    "data-name": "Path 10131",
    d: "M352.627,278.667a3.65,3.65,0,0,1-.57-.915l.842-.366a2.771,2.771,0,0,0,.429.685Z",
    transform: "translate(-352.057 -277.386)",
    fill: "#73c0ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2361",
    "data-name": "Group 2361",
    transform: "translate(228.275 251.603)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3599",
    "data-name": "Rectangle 3599",
    width: 6.485,
    height: 23.856,
    transform: "translate(0 0)",
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2362",
    "data-name": "Group 2362",
    transform: "translate(237.504 249.196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3600",
    "data-name": "Rectangle 3600",
    width: 6.486,
    height: 26.263,
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2363",
    "data-name": "Group 2363",
    transform: "translate(246.858 254.194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3601",
    "data-name": "Rectangle 3601",
    width: 6.485,
    height: 21.265,
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2364",
    "data-name": "Group 2364",
    transform: "translate(256.211 244.338)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3602",
    "data-name": "Rectangle 3602",
    width: 6.486,
    height: 31.121,
    fill: "#78c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2365",
    "data-name": "Group 2365",
    transform: "translate(266.025 247.438)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3603",
    "data-name": "Rectangle 3603",
    width: 6.485,
    height: 28.022,
    fill: "#78c2ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorecord);
export default __webpack_public_path__ + "static/media/norecord.ebfb807f622d124671b363d9c71af72c.svg";
export { ForwardRef as ReactComponent };